<template>
	<ul>
		<li
			v-for="(item, index) in items"
			:key="item.itemid"
			class="cart-item"
			@click.stop.prevent="handleEditItem(item.itemid)"
			@keyup.enter="handleEditItem(item.itemid)"
		>
			<div class="item-info">
				<div class="item-details-section">
					<div class="item-title">
						<button
							class="item-label"
							:aria-label="item.item + '. Click to edit item.'"
							:id="item.itemid"
							@click.stop.prevent="handleEditItem(item.itemid)"
						>
							{{ item.item }}
						</button>
						<ul v-if="item.whofor && item.whofor.trim() !== ''" class="who-for-list">
							<li>For: {{ item.whofor }}</li>
						</ul>
					</div>
					<ul v-if="item.comment" class="comment-list">
						<li>{{ item.comment }}</li>
					</ul>
					<ul v-if="item.options.length" class="options-list">
						<li
							v-for="option in getFilteredOptions(item.options)"
							:key="option.optionid"
							class="item-option"
						>
							+ {{ option.option }}
						</li>
					</ul>
				</div>

				<!-- NOTE: Leaving this here for future update to options to include whether its an addition or subtraction -->
				<!-- <ul v-if="item.subtractions.length" class="options-list">
					<li
						v-for="subtraction in item.subtractions"
						:key="subtraction.id"
						class="item-option"
					>
						- {{ subtraction.label }}
					</li>
				</ul> -->
			</div>
			<div class="qty-price-section">
				<div class="item-price">
					{{ itemSubTotal(index) | toCurrency }}
				</div>
				<div class="item-quantity-wrapper">
					<div class="item-quantity">
						<button
							v-if="showQtyTrashIcon(index)"
							class="item-quantity-delete-button"
							type="button"
							:aria-label="'Delete ' + item.item + ' from cart.'"
							@click.stop.prevent="handleRemove(item.itemid)"
							@keyup.stop.prevent.enter="handleRemove(item.itemid)"
						>
							<i class="fas fa-trash fa-lg item-quantity-delete-icon"></i>
						</button>
						<button
							v-else
							class="item-quantity-button"
							type="button"
							:aria-label="
								'Decrease Quantity for ' + item.item + ' from ' + item.qty + ' to ' + (item.qty - 1)
							"
							@click.stop.prevent="
								handleQuantityDecrease(
									index,
									item.itemid,
									item.options,
									item.whofor,
									item.comment,
									item.qty
								)
							"
							@keyup.stop.prevent.enter="
								handleQuantityDecrease(
									index,
									item.itemid,
									item.options,
									item.whofor,
									item.comment,
									item.qty
								)
							"
						>
							-
						</button>

						<span
							class="item-quantity-value"
							:aria-label="'Edit Quantity for ' + item.item + '. Current quantity ' + item.qty"
							>{{ item.qty }}</span
						>
						<button
							class="item-quantity-button"
							type="button"
							:aria-label="
								'Increase Quantity for ' + item.item + ' from ' + item.qty + ' to ' + (item.qty + 1)
							"
							@click.stop.prevent="
								handleQuantityIncrease(
									index,
									item.itemid,
									item.options,
									item.whofor,
									item.comment,
									item.qty
								)
							"
							@keyup.stop.prevent.enter="
								handleQuantityIncrease(
									index,
									item.itemid,
									item.options,
									item.whofor,
									item.comment,
									item.qty
								)
							"
						>
							+
						</button>
					</div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
import toCurrency from "../filters/toCurrency";
const debounce = require("lodash/debounce");

export default {
	name: "CartItems",
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		restId: {
			type: String,
		},
	},
	filters: {
		toCurrency,
	},
	methods: {
		itemSubTotal(itemIndex) {
			var itemSubTotal = parseFloat(this.items[itemIndex].price);
			var allOptionsSelected = this.items[itemIndex].options;
			allOptionsSelected.forEach((option) => {
				if (option.price) {
					itemSubTotal += parseFloat(option.price);
				}
			});
			return itemSubTotal.toFixed(2);
		},
		showQtyTrashIcon(itemIndex) {
			return this.items[itemIndex].qty == 1 ? true : false;
		},
		getFilteredOptions(allOptions) {
			// returns an array of options sorted so nested options are inserted after the parent option
			return allOptions.filter((option) => !option.parentID);
		},
		handleQuantityIncrease(index, id, options, whofor, comment, qty) {
			qty++;
			this.$emit("edit-item-qty", {
				id: id,
				restId: this.restId,
				qty: qty,
				options: options,
				whofor: whofor,
				comment: comment,
			});
		},
		handleQuantityDecrease(index, id, options, whofor, comment, qty) {
			qty--;
			if (qty === 0) {
				this.handleRemove(id);
				return false;
			}
			this.$emit("edit-item-qty", {
				id: id,
				restId: this.restId,
				qty: qty,
				options: options,
				whofor: whofor,
				comment: comment,
			});
		},
		editItemQty(index, id, options, whofor, comment, itemQty) {
			var qty = this.$refs.input[index].value;
			if (isNaN(qty) || qty === "") {
				alert("Please enter a number for item quantity!");
				this.$refs.input[index].value = itemQty; // set value to match what is saved in server
				return false;
			}
			if (qty === "0") {
				this.handleRemove(id);
				return false;
			}
			this.$emit("edit-item-qty", {
				id: id,
				restId: this.restId,
				qty: qty,
				options: options,
				whofor: whofor,
				comment: comment,
			});
		},
		handleRemove: debounce(
			function (id) {
				this.$emit("remove-item", { id: id, restId: this.restId });
			},
			1000,
			{ leading: true, trailing: false }
		),
		handleEditItem(id) {
			this.$emit("close-cart");
			this.$emit("edit-item", { itemId: id, restId: this.restId });
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
.cart-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 15px;
	border-top: 2px solid $gray_4;
	padding-top: 5px;
	flex-direction: row;
	padding-bottom: 5px;
	z-index: 503;

	&:last-of-type {
		border-bottom: 2px solid $gray_4;
	}
	&:hover {
		border: 2px solid $tomato;
		border-radius: 5px;
		cursor: pointer;
	}
}

.item-quantity-wrapper {
	text-align: center;
	display: flex;
	align-items: center;
	z-index: 504;
}

.item-quantity {
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	font-weight: 500;
}

.item-quantity-button {
	transition: background-color 0.2s ease, transform 0.2s ease;
	color: #ffffff;
	background-color: #f1560f;
	border-radius: 50%;
	display: flex;
	height: 24px;
	width: 24px;
	justify-content: center;
	font-weight: 700;
	font-size: 15px;
	z-index: 504;

	&:hover,
	&:focus {
		background-color: $royal;
		transform: translate(0, -2px);
	}
}

.item-quantity-delete-button {
	transition: transform 0.2s ease;
	background-color: #e3e3e3;
	border-radius: 50%;
	height: 24px;
	width: 24px;
	z-index: 504;

	&:hover,
	&:focus {
		transform: translate(0, -2px);
	}
}

.item-quantity-delete-icon {
	font-size: 14px;
}

.item-quantity-value {
	width: 20px;
	text-align: center;
	margin: 5px;
	font-size: 1.6rem;
	border: 0;
	z-index: 504;

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
}

.remove-item {
	@include transition(color);
	font-weight: 700;
	font-size: 1.2rem;
	text-decoration: none;
	text-transform: uppercase;
	color: $royal;

	&:hover,
	&:focus {
		color: $black;
	}
}

.item-info {
	flex: 1 1 auto;
	padding: 0 10px;
	display: flex;
	justify-content: space-between;
}

.item-details-section {
	display: flex;
	flex-direction: column;
	width: 75%;
}

.item-title {
	font-weight: 700;
	font-size: 1.2rem;
	line-height: 1;
}
.item-label {
	color: $royal;
	z-index: 503;
	&:hover,
	&:focus {
		text-decoration: underline;
	}
}

.options-list {
	line-height: 1;
	display: flex;
	flex-direction: column;
}

.comment-list {
	line-height: 1;
	font-style: italic;
	display: flex;
	flex-direction: column;
}

.who-for-list {
	line-height: 1;
}

.item-option {
	font-weight: 500;
	font-size: 1.2rem;
	display: inline-block;
}

.qty-price-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 10px;
}

.item-price {
	font-size: 14px;
	font-weight: 700;
	color: $royal;
	margin-bottom: 5px;
}
</style>